/**
 * Whose analytics the Overview shows beside the account cards (the one-screen layout,
 * PR 5 of audits/2026-10-29/gui/plan.md): one account at a time, instead of a full block
 * per account under the cards.
 *
 * 🔴 The choice is the screen's own and is checked against the list read now: an account
 * chosen before the list was read again, and no longer in it, falls back to the first
 * one rather than leaving the analytics empty. The reads and the figures are not decided
 * here — every account is still read under `readsInstruments`, exactly as before.
 */
export function analyticsFor(
	list: readonly { xAccountId: string }[],
	chosen: string | null,
): string | null {
	if (chosen !== null && list.some((a) => a.xAccountId === chosen)) return chosen;
	return list[0]?.xAccountId ?? null;
}
